<template>
  <CssbDownloadWatcherComponent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CssbDownloadWatcherComponent from "@/components/FileAccess/cssbDownloadWatcher.vue";

const componentName = "CssbDownloadWatcherRoute";
export default defineComponent({
  name: componentName,
  components: { CssbDownloadWatcherComponent },
});
</script>
